export enum CargoGroupType {
  CARGO = "CARGO",
  HANDLING = "HANDLING",
  PACKING = "PACKING",
}
